import { createFileRoute, redirect } from '@tanstack/react-router';

// See ./index.tsx: the Campaigns name redirects to Sequences.
export const Route = createFileRoute('/campaigns/$campaignId')({
  beforeLoad: ({ params, location }) => {
    throw redirect({
      to: '/sequences/$sequenceId',
      params: { sequenceId: params.campaignId },
      search: location.search,
      replace: true,
    });
  },
});
